const Statuses = {
    0: {
        type: 'active',
        displayedName: 'Healthy',
    },
    1: {
        type: 'processing',
        displayedName: 'Incomplete',
    },
    4: {
        type: 'processing',
        displayedName: 'Processing',
    },
    20: { type: 'inactive', displayedName: 'Error' },
};

export default Statuses;
